import { Link, useLocation } from 'react-router-dom';
import {
  IconHome,
  IconFileText,
  IconTarget,
  IconActivity,
} from '@tabler/icons-react';

export function MicrositeNav({ shareId }: { shareId: string }) {
  const { pathname } = useLocation();
  const items = [
    { href: `/p/${shareId}`, label: 'Home', icon: IconHome },
    { href: `/p/${shareId}/report`, label: 'Report', icon: IconFileText },
    { href: `/p/${shareId}/plan`, label: 'Plan', icon: IconTarget },
    { href: `/p/${shareId}/benefits`, label: 'Benefits', icon: IconActivity },
  ];
  return (
    <nav className="fixed bottom-0 inset-x-0 border-t bg-white/90 backdrop-blur z-10">
      <div
        className="max-w-screen-sm mx-auto flex justify-around py-2 text-sm px-2"
        style={{ paddingBottom: 'calc(env(safe-area-inset-bottom) + 8px)' }}
      >
        {items.map(({ href, label, icon: Icon }) => {
          const active = pathname === href;
          return (
            <Link
              key={href}
              to={href}
              className={`flex flex-col items-center gap-0.5 px-2 py-1 rounded-lg ${active ? 'text-yellow-600' : 'text-gray-400'} hover:text-gray-900`}
            >
              <Icon className="h-5 w-5" />
              <span className="text-[11px] font-medium">{label}</span>
            </Link>
          );
        })}
      </div>
    </nav>
  );
}
